import { DocumentoDTO } from "./documentoDTO";
import { DocumentoProtocolloDTO } from "./protocollo/documento-protocolloDTO";
import { DocumentoGescorDTO } from "./gescor/documeto-gescorDTO";
import { ClassificaDTO } from "./classificaDTO";
import { ClassificaGescorDTO } from "./gescor/classifica-gescorDTO";
import { TipoIstanzaFascicoloDTO } from "./tipo-istanza-fascicoloDTO";


export class MetadatiFascicoloDTO {
  idFascicolo: string;

  segnaturaArchivistica: string;

/*   tipologia: TipoIstanzaFascicoloDTO;

  classifica: ClassificaDTO;

  oggetto: string; */
}